var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [_vm._v("Create Trip")]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body run-form-modal" },
      [
        _c(
          "form-wrapper",
          {
            staticClass: "form-wrapper",
            attrs: { validator: _vm.$v.runDetails },
          },
          [
            !_vm.isSingleUser && !_vm.isSingleTeamMember
              ? _c(
                  "div",
                  [
                    _c(
                      "form-group",
                      {
                        staticClass: "team-member",
                        attrs: { name: "member", label: "Team Member" },
                      },
                      [
                        _c("md-input", {
                          attrs: { type: "hidden" },
                          model: {
                            value: _vm.assignToPublicUserId,
                            callback: function ($$v) {
                              _vm.assignToPublicUserId = $$v
                            },
                            expression: "assignToPublicUserId",
                          },
                        }),
                        _c("vue-select", {
                          attrs: {
                            "data-testid": "create-trip-team-member",
                            reduce: function (fullName) {
                              return fullName.publicUserId
                            },
                            label: "fullName",
                            options: _vm.teamMemberOptions,
                            placeholder: "Select Team Member",
                            searchable: _vm.$root.isDesktop,
                          },
                          model: {
                            value: _vm.assignToPublicUserId,
                            callback: function ($$v) {
                              _vm.assignToPublicUserId = $$v
                            },
                            expression: "assignToPublicUserId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "md-layout create-trip-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item md-size-50" },
                [
                  _c(
                    "md-datepicker",
                    {
                      ref: "mdDatePicker",
                      attrs: {
                        "md-immediately": "",
                        "data-testid": "create-trip-date",
                      },
                      model: {
                        value: _vm.tripDate,
                        callback: function ($$v) {
                          _vm.tripDate = $$v
                        },
                        expression: "tripDate",
                      },
                    },
                    [_c("label", [_vm._v("Trip Date")])]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            on: { click: _vm.onCreateTrip },
          },
          [_vm._v("Create")]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Cancel")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }